import * as React from 'react';

import { IconProps } from '../Icon';

export const ConnectOutlineIcon = ({
  width,
  height,
  className,
  color,
}: IconProps) => (
  <svg
    className={className}
    fill={color}
    height={height}
    viewBox="0 0 24 24"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m17.5 13a4.49021 4.49021 0 0 0 -3.7934 2.10156l-3.86206-2.05829a3.749 3.749 0 0 0 -.129-2.50128l4.42468-2.47436a3.488 3.488 0 1 0 -1.14022-2.56763 3.46006 3.46006 0 0 0 .116.84827l-4.59665 2.57043a3.96058 3.96058 0 0 0 -2.51935-.9187 4 4 0 1 0 2.86145 6.78571l4.18732 2.23162a4.40289 4.40289 0 0 0 -.04877.48267 4.5 4.5 0 1 0 4.5-4.5zm-1-9a1.5 1.5 0 1 1 -1.5 1.5 1.50164 1.50164 0 0 1 1.5-1.5zm-10.5 10a2 2 0 1 1 2-2 2.00229 2.00229 0 0 1 -2 2zm11.5 6a2.5 2.5 0 1 1 2.5-2.5 2.50263 2.50263 0 0 1 -2.5 2.5z" />
  </svg>
);
